import React from 'react';

interface AwardsChatIconProps {
  className?: string;
  color?: string;
  size?: number;
}

const AwardsChatIcon: React.FC<AwardsChatIconProps> = ({
  className = '',
  color = '#0C0E21',
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path
        d="M17.3791 19.7402H7.97913C7.23913 19.7402 6.48913 19.2102 6.23913 18.5202L2.09913 6.93023C1.58913 5.47023 1.95913 4.80023 2.35913 4.50023C2.75913 4.20023 3.50913 4.02023 4.76913 4.92023L8.66913 7.71023C8.78913 7.78023 8.89913 7.81023 8.97913 7.79023C9.06913 7.76023 9.13913 7.68023 9.18913 7.54023L10.9491 2.85023C11.4791 1.45023 12.2591 1.24023 12.6791 1.24023C13.0991 1.24023 13.8791 1.45023 14.4091 2.85023L16.1691 7.54023C16.2191 7.67023 16.2891 7.76023 16.3791 7.79023C16.4691 7.82023 16.5791 7.79023 16.6891 7.70023L20.3491 5.09023C21.6891 4.13023 22.4691 4.32023 22.8991 4.63023C23.3191 4.95023 23.7091 5.66023 23.1591 7.21023L19.1191 18.5202C18.8691 19.2102 18.1191 19.7402 17.3791 19.7402ZM3.35913 5.82023C3.37913 5.96023 3.41913 6.16023 3.51913 6.42023L7.65913 18.0102C7.69913 18.1102 7.87913 18.2402 7.97913 18.2402H17.3791C17.4891 18.2402 17.6691 18.1102 17.6991 18.0102L21.7391 6.71023C21.8791 6.33023 21.9191 6.07023 21.9291 5.92023C21.7791 5.97023 21.5491 6.08023 21.2191 6.32023L17.5591 8.93023C17.0591 9.28023 16.4691 9.39023 15.9391 9.23023C15.4091 9.07023 14.9791 8.65023 14.7591 8.08023L12.9991 3.39023C12.8691 3.04023 12.7491 2.87023 12.6791 2.79023C12.6091 2.87023 12.4891 3.04023 12.3591 3.38023L10.5991 8.07023C10.3891 8.64023 9.95913 9.06023 9.41913 9.22023C8.88913 9.38023 8.28913 9.27023 7.79913 8.92023L3.89913 6.13023C3.66913 5.97023 3.48913 5.87023 3.35913 5.82023Z"
        fill="currentColor"
      />
      <path
        d="M18.1791 22.7602H7.17913C6.76913 22.7602 6.42913 22.4202 6.42913 22.0102C6.42913 21.6002 6.76913 21.2602 7.17913 21.2602H18.1791C18.5891 21.2602 18.9291 21.6002 18.9291 22.0102C18.9291 22.4202 18.5891 22.7602 18.1791 22.7602Z"
        fill="currentColor"
      />
      <path
        d="M15.1791 14.7602H10.1791C9.76913 14.7602 9.42913 14.4202 9.42913 14.0102C9.42913 13.6002 9.76913 13.2602 10.1791 13.2602H15.1791C15.5891 13.2602 15.9291 13.6002 15.9291 14.0102C15.9291 14.4202 15.5891 14.7602 15.1791 14.7602Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default AwardsChatIcon;
